import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

@Directive({
	selector: '[appFitHeightToContent]',
})
export class FitHeightToContentDirective implements AfterViewInit {
	private element = inject(ElementRef<HTMLTextAreaElement>);

	constructor() {}
	ngAfterViewInit() {
		const el: HTMLTextAreaElement = this.element.nativeElement;

		['keydown', 'input'].forEach(event => {
			el.addEventListener(event, () => {
				el.style.removeProperty('height');
				el.style.height = el.scrollHeight + 2 + 'px';
			});
		});
	}
}
